import React from 'react';
import { graphql } from 'gatsby';
import isNil from 'utils/isNil';
import styled from 'styled-components';
import PressHeroSection from 'components/PressPage/PressHeroSection';
import Pagination from 'components/Pagination';
import DemoFormSection from 'components/DemoFormSection';
import useGlobalFooter from 'hooks/useGlobalFooter';
import useGlobalHeader from 'hooks/useGlobalHeader';
import SEO, { createSEO } from '../components/SEO';
import WebsiteLayout from '../layouts/websiteLayout';

const PressTemplate = props => {
  const header = useGlobalHeader();
  const footer = useGlobalFooter();
  const { contentfulPressPage } = props.data;
  const { edges } = props.data.allContentfulPress;

  const { title, richTextDescription, demoFormSection } = contentfulPressPage;

  const pageImages = props.data.allContentfulWebsiteImage;
  let backImg;
  pageImages.edges.forEach(imageItem => {
    if (imageItem.node.internalName === 'bg-roi-01') {
      backImg = !isNil(imageItem.node.image) ? imageItem.node.image : '';
    }
  });

  const seo = createSEO(
    {
      ...contentfulPressPage,
      pageCategory: 'Press',
      canonicalUrl: props.pageContext.currentPage > 1 ? null : contentfulPressPage?.canonicalUrl,
    },
    props
  );

  return (
    <WebsiteLayout
      header={header}
      footer={footer}
      hero={{ backgroundImg: backImg }}
      theme="darkHeroHeader"
    >
      <SEO {...seo} />
      <PressLayout>
        <PressHeroSection
          backgroundImg={backImg}
          title={title}
          description={richTextDescription}
          pressData={edges}
        />
        <Pagination template="press" pageContext={props.pageContext} />
        <DemoFormSection
          backgroundColor={demoFormSection.backgroundColor}
          formTitle={demoFormSection.formTitle}
          description={demoFormSection.description.description}
          title={demoFormSection.title}
          marketoForm={demoFormSection.form.marketoForm}
          redirectUrl={demoFormSection.formRedirectUrl}
        />
      </PressLayout>
    </WebsiteLayout>
  );
};

export default PressTemplate;

export const PressTemplateQuery = graphql`
  query PressTemplateQuery($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulPressPage {
      id
      titleTag
      metaDescription {
        metaDescription
      }
      indexable
      socialSharingImage {
        ... on ContentfulWebsiteImage {
          alt
          image {
            file {
              url
            }
          }
        }
      }
      canonicalUrl
      slug
      title
      richTextDescription {
        json
      }
      demoFormSection {
        backgroundColor
        title
        description {
          description
        }
        formTitle
        form {
          ...InlineMarketingForm
        }
        formRedirectUrl
      }
    }
    allContentfulPress(limit: $limit, skip: $skip, sort: { order: DESC, fields: postDate }) {
      edges {
        node {
          id
          slug
          postTitle
          metaDescription {
            metaDescription
          }
          postDate(formatString: "MMMM DD, YYYY")
        }
      }
    }
    allContentfulWebsiteImage(
      filter: {
        contentful_id: {
          in: [
            "zfuZ1a10xSALJUMgmOqJH" #bg-roi-01
          ]
        }
      }
    ) {
      edges {
        node {
          internalName
          image {
            file {
              url
            }
          }
        }
      }
    }
  }
`;

const PressLayout = styled.div`
  .section-press-hero--wrapper {
  }
`;
